// extracted by mini-css-extract-plugin
export default {"paneItemIndex":"VeiXHoL7o_Qggxw7RSy5"};